<template>
	<div>
		<title-bar :title-stack="titleStack"/>

		<card-component class="has-table has-mobile-sort-spaced" :hasButtonSlot="true" title="一覧" icon="format-list-bulleted">
			<b-button slot="button" type="is-success" @click="$router.push({ name: 'team-new' })">新規作成</b-button>

			<b-table
				:loading="isLoading"
				:paginated="true"
				:per-page="$consts.TABLE_PER_PAGE"
				:striped="true"
				:hoverable="true"
				default-sort="name"
				:data="list"
				@page-change="onPageChange"
				>

				<template slot-scope="props">
					<b-table-column label="チーム名" field="name" sortable>
						{{ props.row.name }}
					</b-table-column>
					<b-table-column label="組織" field="organization" sortable>
						{{ props.row.organization }}
					</b-table-column>
					<b-table-column label="ユニット" field="unit" sortable>
						{{ props.row.unit }}
					</b-table-column>
					<b-table-column label="主催者" field="organizer" sortable>
						{{ props.row.organizer }}
					</b-table-column>
					<b-table-column label=" ">
						<div class="buttons is-right">
							<button :style="{ visibility: getButtonVisibility(props.row.is_show_delete) }" class="button is-small is-info mr-10" type="button" @click="onQrButtonClick(props.row.join_url)">QR</button>
							<button class="button is-small is-warning mr-10" type="button" @click="$router.push({ name: 'team-edit', params: { teamId: props.row.id }})">編集</button>
							<button :style="{ visibility: getButtonVisibility(props.row.is_show_delete) }" class="button is-small is-danger" type="button" @click="onDeleteClick(props.row.id)">削除</button>
						</div>
					</b-table-column>
				</template>

				<section class="section" slot="empty">
					<table-empty :loading="isLoading"></table-empty>
				</section>

				<section class="page-info" slot="bottom-left">
					<page-info :current="currentPage" :data="list"></page-info>
				</section>
			</b-table>
		</card-component>

		<b-modal :active.sync="isQrModalActive" class="join-modal" has-modal-card>
			<div class="modal-card">
				<header class="modal-card-head">
					<p class="modal-card-title">チーム自動加入用URL</p>
				</header>
				<section class="modal-card-body">
					<div class="link mb-10"><a :href="joinUrl" target="_blank">{{ joinUrl }}</a></div>
					<qrcode :value="joinUrl" :options="{ width: 200 }"></qrcode>
					<div class="mt-10">保存はQRコードを右クリック→画像を保存</div>
				</section>
			</div>
		</b-modal>
	</div>

</template>

<style lang="scss" scoped>
.join-modal {
	text-align: center;

	.modal-card {
		border-radius: 10px;
	}
}
.search-wrap {
	flex: 1;

	.search-type,
	.row {
		display: flex;
		align-items: center;
	}

	.search-title {
		margin-right: 10px;
	}
}
</style>

<script>
import TitleBar from '@/components/TitleBar'
import CardComponent from '@/components/CardComponent'
import TableEmpty from '@/components/TableEmpty'
import PageInfo from '@/components/PageInfo'
import SearchBar from '@/components/SearchBar'
import DatePicker from '@/components/DatePicker'
import Qrcode from '@chenfengyuan/vue-qrcode';

export default {
	name: 'Team',
	components: {
		TitleBar,
		CardComponent,
		TableEmpty,
		PageInfo,
		SearchBar,
		DatePicker,
		Qrcode,
	},
	data() {
		return {
			isLoading: false,
			list: [],
			currentPage: 1,
			isQrModalActive: false,
			joinUrl: 'dummy',
		}
	},
	computed: {
		titleStack () {
			return [
				'チーム管理'
			]
		}
	},
	mounted() {
		this.init();
	},
	methods: {
		init: function() {
			this.getData();
		},
		getData: async function() {
			this.isLoading = true;
			let ep = 'teams';
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				this.list = res.data.list;
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				this.isLoading = false;
			}
		},
		getButtonVisibility: function(flg) {
			return flg ? 'visible' : 'hidden';
		},
		onQrButtonClick: function(url) {
			this.joinUrl = url;
			this.isQrModalActive = true;
		},
		onDeleteClick: async function(id) {
			if (!window.confirm(this.$consts.MSG_CONFIRM_DELETE)) {
				return false;
			}

			this.isLoading = true;
			let ep = 'teams/' + id;
			this.$utils.log(ep);

			try {
				let res = await this.$api.delete(ep, null, true);
				this.$utils.log(res);
				this.list.some(function(v, i){
					if (v.id === id) this.list.splice(i, 1);
				}, this);
			} catch (error) {
				this.$utils.log(error);
				this.$utils.toastError(error.response.data.message);
			} finally {
				this.isLoading = false;
			}
		},
		onPageChange: function(val) {
			this.currentPage = val;
		},
	},
}
</script>
